import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PickUpStatus } from 'interfaces';

export const usePickUpStatuses = () => {
   const { t } = useTranslation();

   const pickUpStatusesLegend = useMemo(
      () => [
         {
            status: t('pickup_statuses.verification'),
            description: t('pickup_statuses.description.created'),
            variant: PickUpStatus.CREATED,
         },
         {
            status: t('pickup_statuses.accepted'),
            description: t('pickup_statuses.description.accepted'),
            variant: PickUpStatus.ACCEPTED,
         },
         {
            status: t('report_statuses.canceled'),
            description: t('pickup_statuses.description.rejected'),
            variant: PickUpStatus.REJECTED,
         },
      ],
      [t],
   );

   const PALLET_PICK_UP_STATUSES_BADGE_DATA = useMemo(
      () => ({
         [PickUpStatus.CREATED]: {
            label: t('pickup_statuses.verification'),
            variant: PickUpStatus.CREATED,
         },
         [PickUpStatus.ACCEPTED]: {
            label: t('pickup_statuses.accepted'),
            variant: PickUpStatus.ACCEPTED,
         },
         [PickUpStatus.REJECTED]: {
            label: t('report_statuses.canceled'),
            variant: PickUpStatus.REJECTED,
         },
      }),
      [t],
   );

   return {
      pickUpStatusesLegend,
      PALLET_PICK_UP_STATUSES_BADGE_DATA,
   };
};
